module.exports = __webpack_public_path__ + "./Andy_color_476d2b96cc474fd6402d4c06446f5bee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2023/Andy_color.jpg
// module id = 582
// module chunks = 0